"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _sbUtils = require("@simplybenefits/sb-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BenefitPremiumRow = /*#__PURE__*/function (_PureComponent) {
  function BenefitPremiumRow() {
    (0, _classCallCheck2["default"])(this, BenefitPremiumRow);
    return _callSuper(this, BenefitPremiumRow, arguments);
  }
  (0, _inherits2["default"])(BenefitPremiumRow, _PureComponent);
  return (0, _createClass2["default"])(BenefitPremiumRow, [{
    key: "render",
    value: function render() {
      if (!this.props.benefit) {
        return null;
      }
      var styles = {
        rowCondensed: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          padding: "5px 8px"
        }
      };
      var _this$props = this.props,
        benefit = _this$props.benefit,
        title = _this$props.title;
      var adjustments = benefit.adjustments instanceof Object ? benefit.adjustments.net : benefit.adjustments;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.rowCondensed
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        customStyle: {
          flex: 2
        }
      }, title), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        customStyle: {
          flex: 1,
          textAlign: 'center'
        }
      }, _sbUtils.helpers.numberWithCommas(Math.ceil(benefit.volume))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        customStyle: {
          flex: 1,
          textAlign: 'center'
        }
      }, _sbUtils.helpers.formatNumber(benefit.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        customStyle: {
          flex: 1,
          textAlign: 'center'
        }
      }, _sbUtils.helpers.formatNumber(adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        customStyle: {
          flex: 1,
          textAlign: 'center'
        }
      }, _sbUtils.helpers.formatNumber(benefit.premium + adjustments, 2, true)));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = BenefitPremiumRow;